<footer [ngClass]="verifyUrl()">
    <div class="row custom-container">
        <div class="col-12 col-md-6">
            <div class="footer-search justify-content-start">
                <div class="footer-downloads">
                    <img class="footer-downloads__logo" src="assets/icons/v2/logo_midc_white.svg"
                        alt="Mi Datacrédito" title="Logo Mi Datacrédito" appLazyLoadImg>
                    <span class="footer-downloads__separator" aria-hidden="true"></span>
                    <div class="footer-downloads__stores">
                        <a class="footer-downloads__store" (click)="clic_footer_download_app()"
                            href="https://play.google.com/store/apps/details?id=com.midatacredito&utm_source=midatacredito&utm_medium=footer&utm_campaign=descarga_app_android_footer"
                            target="_blank" rel="noopener">
                            <img src="assets/icons/app/Logo_PlayStore_Blanco.svg"
                                alt="Descarga Mi Datacrédito en Google Play" title="Disponible en Google Play">
                        </a>
                        <a class="footer-downloads__store" (click)="clic_footer_download_app()"
                            href="https://apps.apple.com/co/app/midatacredito/id6752889575?utm_source=midatacredito&utm_medium=footer&utm_campaign=descarga_app_ios_footer"
                            target="_blank" rel="noopener">
                            <img src="assets/icons/app/Icono_AppStore.svg"
                                alt="Descarga Mi Datacrédito en App Store" title="Disponible en App Store">
                        </a>
                    </div>
                </div>
                <div class="social">
                    <p>Encuéntranos en:</p>
                    <div class="social__links">
                        <a id="social_Facebook" target="_blank" rel="noopener"
                            href="https://www.facebook.com/midatacreditoficial">
                            <img src="assets/icons/Facebook_Icono.svg" alt="Facebook">
                        </a>
                        <a id="social_Instagram" target="_blank" rel="noopener"
                            href="https://www.instagram.com/midatacredito_oficial/">
                            <img src="assets/icons/Instagram_Icono.svg" alt="Instagram">
                        </a>
                        <a id="social_Tiktok" target="_blank" rel="noopener"
                            href="https://www.tiktok.com/@midatacredito.com">
                            <img src="assets/icons/Tiktok_Icono.svg" alt="TikTok">
                        </a>
                        <a id="social_X" target="_blank" rel="noopener" href="https://x.com/Midatacredito">
                            <img src="assets/icons/X_Icono.svg" alt="X">
                        </a>
                        <a id="social_Youtube" target="_blank" rel="noopener"
                            href="https://www.youtube.com/@midatacredito_oficial">
                            <img src="assets/icons/Youtube_Icono.svg" alt="YouTube">
                        </a>
                    </div>
                </div>
                <hr class="social-divider">
                @if (footerPay) {
                <div class="imgs-pays d-none d-md-block">
                    <img src="assets/img/logos/Visa_Logo_Blanco.svg" alt="Logo visa" title="Visa" appLazyLoadImg />
                    <img src="assets/img/logos/Mastercard_Logo_Blanco.svg" alt="Logo Mastercard" title="Mastercard"
                        appLazyLoadImg />
                    <img src="assets/img/logos/AMEX_Logo_Blanco.svg" alt="Logo American express"
                        title="American Express" appLazyLoadImg />
                    <img src="assets/img/logos/Diners_Club_Logo_Blanco.svg" alt="Logo diners club"
                        title="Dinners Club" appLazyLoadImg />
                    <img src="assets/img/logos/PSE_Logo_Blanco.svg" alt="Logo PSE" title="PSE" appLazyLoadImg />
                </div>
                }
            </div>
        </div>
        <div class="col-12 col-md-2">
            <app-ui-accordion-item label="Nuestras soluciones" [open]="openSections()[0]" (toggled)="showBodylinks(0, $event)">
                <div class="box-link" (click)="clic_footer_menu($event)">
                    <a href="{{linkMIDC}}" rel="noopener" target="_blank">Midatacrédito</a>
                </div>
                <div class="box-link" (click)="clic_footer_menu($event)">
                    <a href="https://www.midatacredito.com/verifica/?UTM_CAMPAIGN=MiDCReferral&UTM_SOURCE=MenuQN"
                        rel="noopener" target="_blank">Verifica</a>
                </div>
            </app-ui-accordion-item>
        </div>
        <div class="col-12 col-md-2">
            <app-ui-accordion-item label="Legal" [open]="openSections()[1]" (toggled)="showBodylinks(1, $event)">
                <div class="box-link" (click)="clic_footer_menu($event)">
                    <a href="{{url_politica_privacidad}}" target="_blank" rel="noopener">Política de privacidad</a>
                </div>
                <div class="box-link" (click)="clic_footer_menu($event)">
                    <a href="{{url_terminos_condiciones}}" target="_blank" rel="noopener">Términos y condiciones</a>
                </div>
            </app-ui-accordion-item>
        </div>
        <div class="col-12 col-md-2">
            <app-ui-accordion-item label="Contáctanos" [open]="openSections()[2]" (toggled)="showBodylinks(2, $event)">
                <div class="box-link" (click)="clic_footer_menu($event)">
                    <a routerLink="/preguntas-frecuentes" rel="noopener" target="_self">Preguntas frecuentes</a>
                </div>
                <div class="box-link" (click)="irServicioCliente()" (click)="clic_footer_menu($event)">
                    <a target="_self" rel="noopener">Servicio al cliente</a>
                </div>
            </app-ui-accordion-item>
        </div>
        <hr />
    </div>
    <div class="row custom-container align-items-center">
        <div class="col-md-6 col-12 order-md-1 order-2">
            <div class="copyright">
                <p>{{anio}} <b>Experian Colombia S.A.</b> © Derechos reservados.<br />
                    NIT 900.422.614-8.<br />
                    Carrera 7 No. 76 &#9472; 35 Bogotá D.C., Colombia.<br />
                    Email: servicioalciudadano&#64;experian.com</p>
            </div>
        </div>
        <div class="col-md-6 col-12 order-md-2 order-1">
            <div class="copyright">
                <div class="images-copyright">
                    <img src="assets/icons/Logo-Datacredito.svg" alt="Datacrédito Experian"
                        title="Datacrédito Experian">
                    <p class="sic">VIGILADO</p>
                    <a href="https://www.sic.gov.co/" target="_blank"><img src="assets/images/logos/logo_SIC_blanco.png"
                            alt="Superintendencia de industria y comercio"
                            title="Logo Superintendencia de industria y comercio"></a>
                    <img style="width: 50px;" src="assets/icons/new/iq_blanco.png" alt="Iq seguridad en pagos digitales"
                        title="Iq seguridad en pagos digitales">
                </div>
            </div>
        </div>
        <p class="version">
            V.a13-2.1
        </p>
    </div>
    <div class="custom-container disclaminer">
        <hr />
        <p>&#185; Experian <b>no origina créditos</b> ni asume <b>responsabilidad</b> por la aprobación o rechazo de
            créditos ofrecidos por entidades financieras y Fintech.</p>
    </div>
</footer>